export default "__VITE_ASSET__BCQQ6NLu__"